import { createI18n, type I18n } from "vue-i18n";
import type { App } from "vue";
import messages from "@intlify/unplugin-vue-i18n/messages";

import { instance } from "@/api";

let i18n: I18n<
  Record<string, unknown>,
  Record<string, unknown>,
  Record<string, unknown>,
  string,
  false
>;

export const setupI18n = (app: App) => {
  const defaultLocale = "it-IT";
  i18n = createI18n({
    locale: defaultLocale,
    messages,
  });

  instance.defaults.headers.common["Accept-Language"] = defaultLocale;
  document?.querySelector("html")?.setAttribute("lang", defaultLocale);

  app.use(i18n);
};

export const getI18n = () => {
  return i18n;
};
